export default "__VITE_ASSET__Em3w_IMl__"